import type { LayoutProps } from 'Lib/LayoutProps.type';

const BareLayout = ({ children }: LayoutProps) => (
    <div style={{ height: '100vh', width: '100%', margin: '0' }}>{children}</div>
);

export default BareLayout;
